import React, { type ReactNode, useState } from "react";

import ChangelogOpenContext from "./ChangelogOpenContext";

const ChangelogOpenProvider = ({
  children,
}: {
  readonly children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const changelogOpenContext = React.useMemo(() => {
    return { isOpen, setIsOpen };
  }, [isOpen, setIsOpen]);

  return (
    <ChangelogOpenContext.Provider value={changelogOpenContext}>
      {children}
    </ChangelogOpenContext.Provider>
  );
};

export default ChangelogOpenProvider;
